<script setup></script>

<template>
    <Modal v-model="showModal" title="Salary Form" footer-hide :before-close="handleReset">
        <div>
            <Form ref="salaryForm" class="change-pass-form" :model="formData" :rules="formRules" label-position="top">
                <FormItem label="Employee">
                    <EmployeeDropDownList @user-changed="handleUserChanged" />
                </FormItem>

                <FormItem label="Salary" prop="salary">
                    <Input v-model="formData.salary" type="text" />
                </FormItem>

                <Button type="primary" :loading="isLoading" @click="handleSubmitForm"> Submit </Button>
            </Form>
        </div>
    </Modal>
</template>

<style scoped lang="scss"></style>
<script>
import EmployeeDropDownList from '@/components/EmployeeDropDownList/index.vue';
import { setSalary } from '@/services/salary.services';

export default {
    // eslint-disable-next-line vue/no-unused-components
    components: { EmployeeDropDownList },
    data() {
        return {
            errorMessages: [],
            showModal: false,
            isLoading: false,
            user_id: localStorage.getItem('user_id'),
            formData: {
                salary: '',
                user: '',
            },
            formRules: {
                salary: [
                    {
                        required: true,
                        message: 'Please fill in the salary.',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        async handleSubmitForm() {
            this.$refs.salaryForm.validate(async (valid) => {
                if (valid) {
                    const employeeSalary = { salary: parseInt(this.formData.salary), user: this.formData.user };
                    console.log('employee salary: ', employeeSalary);
                    await setSalary(employeeSalary);

                    this.$Message.success('Added salary');
                    this.showModal = false;
                    this.$emit('created');
                } else {
                    this.$Message.error('Fill in the required fields');
                }
            });
        },
        async handleUserChanged(user) {
            this.formData.user = user;
        },

        handleReset() {
            this.$refs.salaryForm.resetFields();
            this.isLoading = false;
            this.errorMessages = [];
            this.showModal = false;
        },
    },
};
</script>
